
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import moment from 'moment';
import 'moment/locale/th'

class BlogCard extends Component {
    render() {
        const { blog, alignment, showPreHeader, showReadMore } = this.props;
        if (!blog) {
            return null;
        }
        moment.locale('th')

        let title = blog.title_th || blog.title;
        let cover_image = blog.cover_image?.url || blog.cover_image?.formats?.medium?.url || blog.cover_image?.formats?.small?.url;
        let slug = blog.slug;
        let description = blog.description || '';
        let writer = blog.writer?.penname || '';
        let publishDate = blog.published_at ? moment(blog.published_at).format('D MMMM YYYY') : '';

        let displayPreHeader = typeof showPreHeader !== "undefined" ? showPreHeader : true;
        let displayReadMore = typeof showReadMore !== "undefined" ? showReadMore : true;

        const isHorizontal = alignment === "horizontal";

        const cardContent = (
            <>
                <div className="card-image padding-top-56">
                    <LazyLoad offset={100} height={0}>
                        <img alt={title} src={cover_image} />
                    </LazyLoad>
                </div>
                <div className="card-detail">
                    {title && (
                        <div className="title">{title}</div>
                    )}
                    {displayPreHeader && description && (
                        <div className="description">{description}</div>
                    )}
                    <div className="meta-info">
                        {writer && (
                            <div className="writer">{writer}</div>
                        )}
                        {publishDate && (
                            <div className="publish-date">{publishDate}</div>
                        )}
                    </div>
                    {displayReadMore && (
                        <div className="read-more">อ่านต่อ</div>
                    )}
                </div>
            </>
        );

        return (
            <Link to={`/blog/${slug}`} className="d-block h-100">
                <div className={`bt-blog-card ${isHorizontal ? 'horizontal' : ''}`}>
                    {isHorizontal ? (
                        <>
                            <div className="col-6">
                                <div className="card-image padding-top-56">
                                    <LazyLoad offset={100} height={0}>
                                        <img alt={title} src={cover_image} />
                                    </LazyLoad>
                                </div>
                            </div>
                            <div className="card-detail col-6">
                                {title && (
                                    <div className="title">{title}</div>
                                )}
                                {displayPreHeader && description && (
                                    <div className="description">{description}</div>
                                )}
                                <div className="meta-info">
                                    {writer && (
                                        <div className="writer">{writer}</div>
                                    )}
                                    {publishDate && (
                                        <div className="publish-date">{publishDate}</div>
                                    )}
                                </div>
                                {displayReadMore && (
                                    <div className="read-more">อ่านต่อ</div>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="col-12">
                            {cardContent}
                        </div>
                    )}
                </div>
            </Link>
        );
    }
}

export default BlogCard